module.exports = __webpack_public_path__ + "static/media/logo.b6230658.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 522
// module chunks = 14